import styled, { css } from 'styled-components';

import { FlexBox } from '@sternum/styled-system';
import { Colors } from '@sternum/web/components/theme/constants';
import { ct } from '@sternum/web/utils/theme';

import { TextOverflowBox } from '../TextOverflowBox';

export const SummaryItemsStyled = styled.div`
  display: flex;
  gap: 52px;
  overflow: auto;
`;

export const SummaryItemsContainer = styled(FlexBox)`
  flex-direction: column;

  ${(props) =>
    !props.w &&
    css`
      width: 160px;
    `}
`;

export const SummaryTitle = styled.div`
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
  color: ${ct({ Dark: Colors.DarkerText, Light: Colors.DarkerText })};
  margin-bottom: 8px;
`;

export const SummaryItemStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  color: ${ct({ Dark: Colors.Dark, Light: Colors.Dark })};
  margin-top: 8px;
  padding-right: 8px;
`;

export const SummaryItemName = styled(TextOverflowBox)`
  font-size: 12px;
  flex: 1;
`;
